var script_loaded = false;
var observer = null; // Globaal gedefinieerde observer

function loadJSscripts() {
  console.log("loadJSscripts aangeroepen"); // Debugging
  if (!script_loaded) {
    script_loaded = true;

    // Lazy-load iframes
    document.querySelectorAll("iframe.lazy").forEach(t => {
      const datasrc = t.dataset.src;
      if (datasrc != null) {
        t.src = datasrc;
      }
    });

    // Lazy-load scripts
    const scripts = document.getElementsByTagName("script");
    for (let i = 0; i < scripts.length; i++) {
      const scr = scripts[i];
      if (scr.getAttribute("data-src") !== null) {
        scr.setAttribute("src", scr.getAttribute("data-src"));
        delete scr.dataset.src;
      }
      if (scr.getAttribute("type") === "text/lazyload") {
        const e = document.createElement("script");
        for (let a = 0; a < scr.attributes.length; a++) {
          const attr = scr.attributes[a];
          e.setAttribute(attr.name, attr.value);
        }
        e.type = "text/javascript";
        e.innerHTML = scr.innerHTML;
        scr.parentNode.removeChild(scr);
        scr.parentNode.insertBefore(e, scr);
      }
    }

    // Lazy-load stylesheets
    const links = document.getElementsByTagName("link");
    for (let i = 0; i < links.length; i++) {
      const lnk = links[i];
      if (lnk.getAttribute("data-href") !== null) {
        lnk.setAttribute("href", lnk.getAttribute("data-href"));
        delete lnk.dataset.href;
      }
    }

    // Event voor andere scripts om op in te haken
    document.dispatchEvent(new CustomEvent("asyncLazyLoad"));
  } else {
    console.log("loadJSscripts al uitgevoerd, wordt overgeslagen"); // Debugging
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const lazyTrigger = document.querySelector("#lazy-init");
  if (!lazyTrigger) {
    console.warn("⚠️ Geen #lazy-init element gevonden, fallback naar directe uitvoering.");
    loadJSscripts(); // Fallback: voer loadJSscripts direct uit
    return;
  }

  // Initialiseer observer
  observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        console.log("lazy-init element in beeld, loadJSscripts wordt uitgevoerd"); // Debugging
        loadJSscripts();
        obs.disconnect();
      }
    });
  });

  observer.observe(lazyTrigger);
});